<template>
    <div class="research-graph-block">
        <graph-triple-panel
            :graph-title="graphTitle"
            :table-title="tableTitle"
            :graph-data="graphData"
            :triples="triples"
            :page-size="pageSize"
        />
    </div>
</template>

<script>
import GraphTriplePanel from './graph_triple_panel.vue';

export default {
    name: 'ResearchGraphBlock',
    components: {
        GraphTriplePanel,
    },
    props: {
        graphTitle: {
            type: String,
            default: '三元组关系图',
        },
        tableTitle: {
            type: String,
            default: '三元组数据表',
        },
        // { nodes, edges, triples }
        chartData: {
            type: Object,
            default: () => ({ nodes: [], edges: [], triples: [] }),
        },
        pageSize: {
            type: Number,
            default: 10,
        },
        // 图谱最多展示节点数
        nodeLimit: {
            type: Number,
            default: 50,
        },
    },
    computed: {
        graphData() {
            const nodes = (this.chartData.nodes || []).slice(0, this.nodeLimit);
            const nodeIds = new Set(nodes.map((item) => item.id));
            const edges = (this.chartData.edges || []).filter(
                (item) => nodeIds.has(item.source) && nodeIds.has(item.target)
            );
            return { nodes, edges };
        },
        triples() {
            return this.chartData.triples || [];
        },
    },
};
</script>
